import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ILead } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IOpenForm } from "./Lead";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Filter, IFilter } from "./Filter";
import { Tag } from "primereact/tag";
import { LeadHistory } from "./History";
import { BulkReAssignLead } from "./BulkReAssignLead";
import { ReassignHistory } from "./ReassignHistory";
import { Dialog } from "primereact/dialog";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false, status: [] } as { data: ILead[], count: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [filter, setFilter] = useState<IFilter>({});
    const dt = useRef<any>(null);
    const [selectedLead, setSelectedLead] = useState<any[]>([]);
    const [openleadForm, setOpenleadForm] = useState({ singleData: {}, open: false } as IOpenForm);
    const [duplicateModal, setDuplicateModal] = useState({
        open: false,
        leadId: 0,
        data: []
    });
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'updatedAt',
        sortOrder: -1
    });
    const [historyModal, setHistoryModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reassignhistoryModal, setReassignhistoryModal] = useState({ singleData: {}, open: false } as IOpenForm);

    const hideHistoryDialog = () => {
        setHistoryModal({ singleData: {}, open: false })
    };

    const hideReassignHistoryDialog = () => {
        setReassignhistoryModal({ singleData: {}, open: false })
    };

    const showHistoryDialog = (rowData: ILead) => {
        setHistoryModal({ singleData: rowData, open: true })
    };

    useEffect(() => {
        loadTableData();
    }, [lazyParams, filter, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };


    const showDuplicateDialog = async (rowData: any) => {

        const response = await Fetch(
            `Duplicate/GetDuplicateLeadDetails?leadId=${rowData.id}`,
            "GET",
            null,
            null,
            props.toast
        );

        if (response) {
            const data = await response.json();

            setDuplicateModal({
                open: true,
                leadId: rowData.id,
                data: data
            });
        }
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const formattedFilter = {
            ...filter,
            fromDate: filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : undefined,
            toDate: filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : undefined,
        };
        const response = await Fetch("leads", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(formattedFilter)}`, props.toast);
        if (response) {
            const data: { leads: ILead[], count: number, status: { id: number, name: string, count: number }[] } = await response.json();
            setTableData({ data: data.leads, count: data.count, status: data.status, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    // const openNew = () => {
    //     props.setModal({ open: true, singleData: { statusId: 5 } });
    // };

    const openEdit = (rowDatauser: ILead) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const RemoveLead = async (rowData: ILead) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`leads/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Lead Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: ILead) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.contactName}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveLead(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {/* {props.hasPermission("Lead", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                )} */}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Lead</h4>
                </div>
            </div>
            <div className="flex gap-4">
                {props.hasPermission("Lead", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}

                {selectedLead.length > 0 && (
                    <Button label="Re assign Lead" icon="pi pi-plus" className="p-button-sm p-button-success p-button-rounded" onClick={() => { setOpenleadForm({ singleData: {}, open: true }); }} />
                )}
            </div>
        </div>
    );

    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="flex align-items-center gap-2">
                {rowData?.duplicateCount > 0 && (
                    <div className="relative">
                        <Button
                            icon="pi pi-copy"
                            className="p-button-rounded p-button-outlined p-button-warning p-button-sm"
                            tooltip="View Duplicate Leads"
                            onClick={() => showDuplicateDialog(rowData)}
                        />
                        <span
                            style={{
                                position: "absolute",
                                top: "-8px",
                                right: "-8px",
                                background: "#f59e0b",
                                color: "#fff",
                                borderRadius: "50%",
                                minWidth: "18px",
                                height: "18px",
                                fontSize: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 600
                            }}
                        >
                            {rowData.duplicateCount}
                        </span>
                    </div>
                )}

                {props.hasPermission("Lead", "Edit") && (
                    <Button
                        icon="pi pi-pencil"
                        className="p-button-rounded p-button-text p-button-success p-button-sm"
                        onClick={() => openEdit(rowData)}
                        tooltip="Edit"
                    />
                )}

                {props.hasPermission("Lead", "History") && (
                    <Button
                        icon="pi pi-clock"
                        className="p-button-rounded p-button-text p-button-info p-button-sm"
                        onClick={() => showHistoryDialog(rowData)}
                        tooltip="History"
                    />
                )}

                {props.hasPermission("Lead", "ReassignHistory") && (
                    <Button
                        icon="pi pi-arrow-right-arrow-left"
                        className="p-button-rounded p-button-text p-button-secondary p-button-sm"
                        onClick={() =>
                            setReassignhistoryModal({
                                singleData: rowData,
                                open: true
                            })
                        }
                        tooltip="Reassign History"
                    />
                )}
            </div>
        );
    };
    const createdAtBody = (rowData: ILead) => {
        return (
            <span>{rowData.createdAt ? format(new Date(rowData.createdAt + "Z"), 'dd/MM/yyyy') : '-'}</span>
        );
    }
    const updatedAtBody = (rowData: ILead) => {
        return (
            <span>{rowData.updatedAt ? format(new Date(rowData.updatedAt + "Z"), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const ReassignedDate = (rowData: ILead) => {
        return (
            <span>{rowData.reassignedAt ? format(new Date(rowData.reassignedAt + "Z"), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const statusBody = (rowData: ILead) => {
        return (
            <Tag severity={rowData.isLeadActive ? 'success' : 'danger'} value={rowData.statusName} rounded></Tag>
        );
    }



    const copyToClipboard = async (value: any, type: any) => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);

            props.toast.current.show({
                severity: 'success',
                detail: `${type} copied successfully`,
                life: 1500
            });
        } catch (error) {
            console.error("Failed to copy:", error);
        }
    };


    const contactNumberBody = (rowData: ILead) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contactContact || '-'}</span>

                {rowData.contactContact && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact number"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contactContact,
                                'Contact number'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const emailBody = (rowData: ILead) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contactEmail || '-'}</span>

                {rowData.contactEmail && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy email"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contactEmail,
                                'Email'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const contactNameBody = (rowData: ILead) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contactName || '-'}</span>

                {rowData.contactName && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact name"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contactName,
                                'Contact name'
                            )
                        }
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <Filter header={
                <div className="flex align-items-center justify-content-end gap-4">
                    Filter
                    <div className="flex align-items-center justify-content-end gap-2 ml-auto">
                        {/* {tableData.status.map((s) => {
                            // return (
                            //     // <Tag key={s.id} onClick={() => setFilter((prev) => ({ ...prev, statusId: s.id }))} severity={filter.status_ID === s.id ? 'warning' : 'info'} value={`${s.name}: ${s.count}`} rounded></Tag>
                            // )
                        })} */}
                    </div></div>} loading={tableData.loading} hasPermission={props.hasPermission} filter={filter} setFilter={setFilter} />
            <DataTable className="no-copy-table" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                selectionMode="checkbox" selection={selectedLead} onSelectionChange={(e) => setSelectedLead(e.value)}

            >
                <Column selectionMode="multiple"></Column>
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="contactName" header="Customer" body={contactNameBody} />
                <Column field="contactContact" header="Contact No." body={contactNumberBody} />
                <Column field="contactEmail" header="Email" body={emailBody} />
                <Column field="sourceName" header="Source" sortable />
                <Column field="assignedToName" header="Sales Manager" />
                <Column field="statusName" header="Status" sortable body={statusBody} />
                <Column field="createdBy" header="CreatedBy" />
                <Column field="createdAt" header="CreatedAt" sortable body={createdAtBody} />
                <Column field="updatedBy" header="UpdatedBy" />
                <Column field="updatedAt" header="UpdatedAt" sortable body={updatedAtBody} />
                <Column field="reassignedAt" header="ReassignedAt" body={ReassignedDate} />
                <Column field="referedBy" header="ReferredBy" />

                <Column header="Actions" body={actionBodyTemplate} />
            </DataTable>
            {props.hasPermission("Lead", "History") && <LeadHistory hasPermission={props.hasPermission} singleData={historyModal.singleData} open={historyModal.open} hideDialog={hideHistoryDialog} toast={props.toast}></LeadHistory>}
            <ConfirmDialog />
            {props.hasPermission("Lead", "ReassignHistory") && <ReassignHistory hasPermission={props.hasPermission} singleData={reassignhistoryModal.singleData} open={reassignhistoryModal.open} hideDialog={hideReassignHistoryDialog} toast={props.toast}></ReassignHistory>}

            <BulkReAssignLead contacts={selectedLead} hasPermission={props.hasPermission} singleData={openleadForm.singleData} open={openleadForm.open} hideDialog={() => setOpenleadForm({ singleData: {}, open: false })}
                toast={props.toast}
                reloadData={props.reloadData}
            />

            <Dialog
                header="Duplicate Leads"
                visible={duplicateModal.open}
                style={{ width: "70vw" }}
                onHide={() =>
                    setDuplicateModal({
                        open: false,
                        leadId: 0,
                        data: []
                    })
                }
            >
                <DataTable
                    value={duplicateModal.data}
                    responsiveLayout="scroll"
                    stripedRows
                    showGridlines
                    className="no-copy-table"
                >
                    <Column field="id" header="Lead Id" />
                    <Column field="contactName" header="Customer" />
                    <Column field="mobile" header="Mobile" body={contactNumberBody} />
                    <Column field="email" header="Email" body={emailBody} />
                    <Column field="source_Name" header="Source" />
                    <Column field="assignedToName" header="Sales Manager" />
                    <Column field="statusName" header="Status" sortable body={statusBody} />
                    <Column field="createdBy" header="CreatedBy" />

                    <Column
                        field="createdAt"
                        header="Created At"
                        body={(rowData) =>
                            rowData.createdAt
                                ? format(
                                    new Date(rowData.createdAt + "Z"),
                                    "dd/MM/yyyy"
                                )
                                : "-"
                        }
                    />
                </DataTable>
            </Dialog>
        </>
    );
}
